import React from "react";
import { motion } from "framer-motion";

const transition = { duration: 1.7, ease: "easeInOut" };

export const SamAndBoBudget = () => {
  const p = "M11 103l8.9-4.952 8.9-.143 8.9-19 8.9-10 8.9 5.047 8.9 1.81h17.8l8.9-6.238 8.9-11.429 8.9-5.714 8.9 4.762 8.9-12.714 8.9-2.477L144.5 51l8.9-3.714h17.8l8.9-1.238h8.9l8.9 7 8.9-2.477 8.9-11.952 9.9-2 7.9-7.905h8.9L251.3 25l8.9 1.238";
  return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="292"
        height="105"
        fill="none"
        viewBox="0 0 292 105"
      >
        <path
          stroke="#31455E"
          strokeDasharray="3.48 4.35"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.739"
          d="M11 103l267-91"
        ></path>
        <motion.path
          stroke="url(#paint0_linear_568_3977)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3.478"
          d={p}
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={transition}
        ></motion.path>
        <motion.g
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.25, ease: "easeInOut", delay: 1.7 }}
        >
          <path
            fill="#0DB100"
            d="M269.591 41.656l-5.088-5.412-5.089 5.412h-29.317a3.478 3.478 0 00-3.478 3.479v11.083a3.478 3.478 0 003.478 3.478h58.184a3.478 3.478 0 003.478-3.478V45.134a3.478 3.478 0 00-3.478-3.478h-18.69z"
          ></path>
          <g fill="#010912" clipPath="url(#clip0_568_3977)">
            <path d="M239.223 54.089c1.441 0 2.508-.847 2.508-2.134 0-.88-.484-1.53-1.21-1.86v-.032a1.88 1.88 0 001.001-1.695c0-1.276-1.067-2.002-2.387-2.002-1.1 0-1.936.54-2.299 1.288l1.023.55c.242-.386.616-.66 1.243-.66.627 0 1.133.418 1.133 1.023 0 .527-.308 1-1.1 1h-.693v1.078h.572c.946 0 1.419.54 1.419 1.133 0 .683-.583 1.123-1.298 1.123-.759 0-1.243-.342-1.474-.903l-1.1.485c.374.924 1.342 1.606 2.662 1.606zm3.331-7.645v1.165h3.267l-2.629 6.303 1.287.242 2.772-6.864v-.846h-4.697zM250.679 54h1.276v-1.276H253v-1.132h-1.045v-5.148h-1.067l-3.509 5.411v.87h3.3V54zm-1.815-2.376l1.859-3.025v3.026h-1.859zm10.172 2.465c.616 0 1.21-.253 1.639-.77l.022.01v.672h1.232v-5.368h-1.232v2.573c0 1.155-.66 1.76-1.375 1.76-.737 0-1.067-.33-1.067-1.397v-2.937h-1.232V51.9c0 1.595.825 2.189 2.013 2.189zm4.456-.088h1.232v-2.695c0-1.056.55-1.64 1.386-1.64.737 0 1.166.364 1.166 1.497V54h1.232v-3.157c0-1.617-.792-2.288-1.969-2.288-.704 0-1.353.286-1.793.814h-.022v-.737h-1.232V54zm8.798.088c.77 0 1.353-.297 1.749-.814h.011V54h1.177v-8.096h-1.221v3.387h-.011c-.407-.483-1.012-.736-1.716-.736-1.474 0-2.596 1.166-2.596 2.783 0 1.66 1.122 2.75 2.607 2.75zm.187-1.122c-.902 0-1.54-.672-1.54-1.617 0-1.035.693-1.684 1.551-1.684.924 0 1.562.727 1.562 1.684 0 .968-.693 1.617-1.573 1.617zm9.263-1.716c0-1.563-1.023-2.695-2.53-2.695-1.573 0-2.695 1.11-2.695 2.76 0 1.683 1.155 2.773 2.783 2.773 1.155 0 1.826-.43 2.277-1.012l-.858-.737c-.275.34-.715.627-1.353.627-.836 0-1.419-.462-1.573-1.243h3.916c.011-.088.033-.275.033-.473zm-2.541-1.584c.704 0 1.144.44 1.298 1.088h-2.684c.176-.704.704-1.089 1.386-1.089zM283.011 54h1.232V51.46c0-.88.528-1.552 1.463-1.552.088 0 .231.011.374.023v-1.375h-.154c-.649 0-1.243.319-1.661.88h-.022v-.803h-1.232V54zM235.111 50.064c0-1.012-.675-1.273-1.702-1.595-.552-.168-.813-.314-.813-.598 0-.276.223-.437.621-.437.338 0 .752.123 1.173.43l.606-.752a3.212 3.212 0 00-1.372-.62v-.967h-.736v.936c-.897.107-1.419.697-1.419 1.487 0 .966.775 1.265 1.633 1.526.629.191.874.337.874.675 0 .29-.26.475-.644.475-.414 0-.927-.177-1.357-.59l-.628.758c.452.438.981.69 1.533.775v.912h.744v-.897c.912-.107 1.487-.675 1.487-1.518z"></path>
          </g>
          <path
            fill="#0DB100"
            fillRule="evenodd"
            d="M264.412 32.824a5.412 5.412 0 100-10.824 5.412 5.412 0 000 10.824zm-.001-3.609a1.804 1.804 0 100-3.607 1.804 1.804 0 000 3.607z"
            clipRule="evenodd"
          ></path>
        </motion.g>
        <defs>
          <linearGradient
            id="paint0_linear_568_3977"
            x1="63.495"
            x2="94.542"
            y1="21.905"
            y2="109.143"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.417" stopColor="#FF2800"></stop>
            <stop offset="0.613" stopColor="#FE9002"></stop>
            <stop offset="0.736" stopColor="#0DB100"></stop>
          </linearGradient>
          <clipPath id="clip0_568_3977">
            <path
              fill="#fff"
              d="M0 0H55.923V14.432H0z"
              transform="translate(230.228 42.56)"
            ></path>
          </clipPath>
        </defs>
      </svg>
  );
}

export const LucasBudget = () => {
  const p = "M11 103l8.9-.952 8.9-.143h8.9l8.9-9 8.9-.953 8.9-.19 8.9-5h8.9l8.9-17.238 8.9 4.571 8.9-5.714 8.9 4.762 8.9-12.714 8.9-10.477L144.5 51l8.9-14.714h17.8l8.9-6.238h8.9l8.9-9 8.9-2.477 8.9-11.952 9.9 6 7.9.095h8.9L251.3 9l8.9-.762";
  return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="292"
        height="105"
        fill="none"
        viewBox="0 0 292 105"
      >
        <path
          stroke="#31455E"
          strokeDasharray="3.48 4.35"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.739"
          d="M11 103l267-91"
        ></path>
        <motion.path
          stroke="url(#paint0_linear_568_3978)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3.478"
          d={p}
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={transition}
        ></motion.path>
        <motion.g
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.25, ease: "easeInOut", delay: 1.7 }}
        >
          <path
            fill="#FE7302"
            fillRule="evenodd"
            d="M264.412 12.824a5.412 5.412 0 100-10.824 5.412 5.412 0 000 10.824zm-.001-3.609a1.804 1.804 0 100-3.607 1.804 1.804 0 000 3.607z"
            clipRule="evenodd"
          ></path>
        </motion.g>
        <defs>
          <linearGradient
            id="paint0_linear_568_3978"
            x1="63.495"
            x2="94.542"
            y1="21.905"
            y2="109.143"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.417" stopColor="#FF2800"></stop>
            <stop offset="0.613" stopColor="#FE9002"></stop>
            <stop offset="0.736" stopColor="#0DB100"></stop>
          </linearGradient>
          <clipPath id="clip0_568_3978">
            <path
              fill="#fff"
              d="M0 0H55.923V14.432H0z"
              transform="translate(230.228 22.56)"
            ></path>
          </clipPath>
        </defs>
      </svg>
  );
}

export const EmilyBudget = () => {
  const p = "M11 103l8.9-.952 8.9-4.143 8.9-3 8.9-2 8.9-2.953 8.9 1.81 8.9-8h8.9l8.9 1.762 8.9 3.571 8.9-2.714 8.9-29.238 8.9-12.714 8.9-2.477L144.5 51l8.9-3.714 8.9-7h8.9l8.9-1.238 8.9-1 8.9-1 8.9 5.523 8.9-3.952 9.9-8 7.9-7.905h8.9L251.3 19l8.9 5.238";
  return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="292"
        height="105"
        fill="none"
        viewBox="0 0 292 105"
      >
      <path
        stroke="#31455E"
        strokeDasharray="3.48 4.35"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.739"
        d="M11 103l267-91"
      ></path>
      <motion.path
        stroke="url(#paint0_linear_568_4015)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3.478"
        d={p}
        initial={{ pathLength: 0 }}
        animate={{ pathLength: 1 }}
        transition={transition}
      ></motion.path>
      <motion.g
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3, ease: "easeInOut", delay: 1.7 }}
      >
        <path
          fill="#0DB100"
          d="M269.591 38.656l-5.088-5.412-5.089 5.412h-27.317a3.478 3.478 0 00-3.478 3.478v11.084a3.478 3.478 0 003.478 3.478h56.184a3.478 3.478 0 003.478-3.478V42.134a3.478 3.478 0 00-3.478-3.478h-18.69z"
        ></path>
        <g fill="#010912" clipPath="url(#clip0_568_4015)">
          <path d="M243.905 51h1.276v-1.276h1.045v-1.132h-1.045v-5.148h-1.067l-3.509 5.411v.87h3.3V51zm-1.815-2.376l1.859-3.025v3.026h-1.859zm7.69 2.453c1.518 0 2.717-.825 2.717-2.155 0-1.034-.583-1.727-1.309-2.002v-.023c.451-.186.935-.813.935-1.584 0-1.199-.968-1.947-2.343-1.947-1.32 0-2.321.705-2.321 1.947 0 .76.473 1.364.924 1.584v.023c-.715.285-1.298.978-1.298 2.002 0 1.276 1.133 2.156 2.695 2.156zm0-4.707c-.649 0-1.111-.374-1.111-.935 0-.507.451-.947 1.111-.947.649 0 1.122.407 1.122.947 0 .56-.462.934-1.122.934zm0 3.575c-.781 0-1.397-.517-1.397-1.188 0-.715.561-1.221 1.397-1.221s1.408.505 1.408 1.22c0 .627-.561 1.188-1.408 1.188zm8.82 1.144c.616 0 1.21-.253 1.639-.77l.022.01v.672h1.232v-5.368h-1.232v2.573c0 1.155-.66 1.76-1.375 1.76-.737 0-1.067-.33-1.067-1.397v-2.937h-1.232V48.9c0 1.595.825 2.189 2.013 2.189zm4.456-.088h1.232v-2.695c0-1.056.55-1.64 1.386-1.64.737 0 1.166.364 1.166 1.497V51h1.232v-3.157c0-1.617-.792-2.288-1.969-2.288-.704 0-1.353.286-1.793.814h-.022v-.737h-1.232V51zm8.797.088c.77 0 1.353-.297 1.749-.814h.011V51h1.177v-8.096h-1.221v3.387h-.011c-.407-.483-1.012-.736-1.716-.736-1.474 0-2.596 1.166-2.596 2.783 0 1.66 1.122 2.75 2.607 2.75zm.187-1.122c-.902 0-1.54-.672-1.54-1.617 0-1.035.693-1.684 1.551-1.684.924 0 1.562.727 1.562 1.684 0 .968-.693 1.617-1.573 1.617zm9.264-1.716c0-1.563-1.023-2.695-2.53-2.695-1.573 0-2.695 1.11-2.695 2.76 0 1.683 1.155 2.773 2.783 2.773 1.155 0 1.826-.43 2.277-1.012l-.858-.737c-.275.34-.715.627-1.353.627-.836 0-1.419-.462-1.573-1.243h3.916c.011-.088.033-.275.033-.473zm-2.541-1.584c.704 0 1.144.44 1.298 1.088h-2.684c.176-.704.704-1.089 1.386-1.089zM282.574 51h1.232V48.46c0-.88.528-1.552 1.463-1.552.088 0 .231.011.374.023v-1.375h-.154c-.649 0-1.243.319-1.661.88h-.022v-.803h-1.232V51zM239.111 47.064c0-1.012-.675-1.273-1.702-1.595-.552-.168-.813-.314-.813-.598 0-.276.223-.437.621-.437.338 0 .752.123 1.173.43l.606-.752a3.213 3.213 0 00-1.372-.62v-.967h-.736v.936c-.897.107-1.419.697-1.419 1.487 0 .966.775 1.265 1.633 1.526.629.191.874.337.874.674 0 .292-.26.476-.644.476-.414 0-.927-.177-1.357-.59l-.628.758c.452.438.981.69 1.533.775v.912h.744v-.897c.912-.107 1.487-.675 1.487-1.518z"></path>
        </g>
        <path
          fill="#0DB100"
          fillRule="evenodd"
          d="M264.412 29.824a5.412 5.412 0 100-10.824 5.412 5.412 0 000 10.824zm-.001-3.609a1.804 1.804 0 100-3.607 1.804 1.804 0 000 3.607z"
          clipRule="evenodd"
        ></path>
      </motion.g>
      <defs>
        <linearGradient
          id="paint0_linear_568_4015"
          x1="63.495"
          x2="94.542"
          y1="21.905"
          y2="109.143"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.417" stopColor="#FF2800"></stop>
          <stop offset="0.613" stopColor="#FE9002"></stop>
          <stop offset="0.736" stopColor="#0DB100"></stop>
        </linearGradient>
        <clipPath id="clip0_568_4015">
          <path
            fill="#fff"
            d="M0 0H55.923V14.432H0z"
            transform="translate(230.228 39.56)"
          ></path>
        </clipPath>
      </defs>
      </svg>
  );
}

export const MateoBudget = () => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    width="292"
    height="105"
    fill="none"
    viewBox="0 0 292 105"
  >
    <path
      stroke="#31455E"
      strokeDasharray="3.48 4.35"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.739"
      d="M11 103l267-91"
    ></path>
    <motion.path
      stroke="url(#paint0_linear_568_4024)"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3.478"
      d="M11 103l8.9-4.952 8.9-.143 8.9-8 8.9-10 8.9 5.047 8.9 1.81h17.8l8.9-6.238 8.9-3.429 8.9-5.714 8.9 4.762 8.9-12.714 8.9-2.477L144.5 62l8.9-6.714h17.8l8.9-1.238 8.9 2 8.9-3 8.9-2.477 8.9 4.048 9.9-9 7.9-7.905h8.9L251.3 34l8.9 1.238"
      initial={{ pathLength: 0 }}
      animate={{ pathLength: 1 }}
      transition={transition}
    ></motion.path>
    <motion.g
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3, ease: "easeInOut", delay: 1.7 }}
    >
      <path
        fill="#0DB100"
        d="M269.591 49.656l-5.088-5.412-5.089 5.412h-29.317a3.478 3.478 0 00-3.478 3.479v11.083a3.478 3.478 0 003.478 3.478h58.184a3.478 3.478 0 003.478-3.478V53.134a3.478 3.478 0 00-3.478-3.478h-18.69z"
      ></path>
      <g fill="#010912" clipPath="url(#clip0_568_4024)">
        <path d="M236.715 62h4.851v-1.166h-2.915l-.011-.033 1.595-1.66c.957-.99 1.254-1.706 1.254-2.541 0-1.386-1.122-2.223-2.365-2.223-1.232 0-2.013.616-2.442 1.43l.913.65c.341-.595.836-.892 1.441-.892.682 0 1.155.507 1.155 1.178 0 .648-.451 1.198-1.067 1.847l-2.431 2.563.022.848zm7.559 0h1.276v-7.556h-1.034l-2.211 1.605.605.947 1.364-1.024v6.029zm5.703.089c1.826 0 2.904-1.584 2.904-3.861 0-2.465-1.199-3.861-2.904-3.861-1.815 0-2.904 1.573-2.904 3.86 0 2.454 1.199 3.862 2.904 3.862zm0-1.188c-.968 0-1.606-1.002-1.606-2.674 0-1.694.616-2.683 1.606-2.683.99 0 1.606.99 1.606 2.684 0 1.682-.594 2.672-1.606 2.672zm9.124 1.188c.616 0 1.21-.253 1.639-.77l.022.01v.672h1.232v-5.368h-1.232v2.573c0 1.155-.66 1.76-1.375 1.76-.737 0-1.067-.33-1.067-1.397v-2.937h-1.232V59.9c0 1.595.825 2.189 2.013 2.189zm4.456-.088h1.232v-2.695c0-1.056.55-1.64 1.386-1.64.737 0 1.166.364 1.166 1.497V62h1.232v-3.157c0-1.617-.792-2.288-1.969-2.288-.704 0-1.353.286-1.793.814h-.022v-.737h-1.232V62zm8.797.088c.77 0 1.353-.297 1.749-.814h.011V62h1.177v-8.096h-1.221v3.387h-.011c-.407-.483-1.012-.736-1.716-.736-1.474 0-2.596 1.166-2.596 2.783 0 1.66 1.122 2.75 2.607 2.75zm.187-1.122c-.902 0-1.54-.672-1.54-1.617 0-1.035.693-1.684 1.551-1.684.924 0 1.562.727 1.562 1.684 0 .968-.693 1.617-1.573 1.617zm9.264-1.716c0-1.563-1.023-2.695-2.53-2.695-1.573 0-2.695 1.11-2.695 2.76 0 1.683 1.155 2.773 2.783 2.773 1.155 0 1.826-.43 2.277-1.012l-.858-.737c-.275.34-.715.627-1.353.627-.836 0-1.419-.462-1.573-1.243h3.916c.011-.088.033-.275.033-.473zm-2.541-1.584c.704 0 1.144.44 1.298 1.088h-2.684c.176-.704.704-1.089 1.386-1.089zM283.075 62h1.232V59.46c0-.88.528-1.552 1.463-1.552.088 0 .231.011.374.023v-1.375h-.154c-.649 0-1.243.319-1.661.88h-.022v-.803h-1.232V62zM235.111 58.064c0-1.012-.675-1.273-1.702-1.595-.552-.168-.813-.314-.813-.598 0-.276.223-.437.621-.437.338 0 .752.123 1.173.43l.606-.752a3.212 3.212 0 00-1.372-.62v-.967h-.736v.936c-.897.107-1.419.697-1.419 1.487 0 .966.775 1.265 1.633 1.526.629.191.874.337.874.675 0 .29-.26.475-.644.475-.414 0-.927-.177-1.357-.59l-.628.758c.452.438.981.69 1.533.775v.912h.744v-.897c.912-.107 1.487-.675 1.487-1.518z"></path>
      </g>
      <path
        fill="#0DB100"
        fillRule="evenodd"
        d="M264.412 40.824a5.412 5.412 0 100-10.824 5.412 5.412 0 000 10.824zm-.001-3.609a1.804 1.804 0 100-3.607 1.804 1.804 0 000 3.607z"
        clipRule="evenodd"
      ></path>
    </motion.g>
    <defs>
      <linearGradient
        id="paint0_linear_568_4024"
        x1="63.495"
        x2="94.542"
        y1="21.905"
        y2="109.143"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.417" stopColor="#FF2800"></stop>
        <stop offset="0.613" stopColor="#FE9002"></stop>
        <stop offset="0.736" stopColor="#0DB100"></stop>
      </linearGradient>
      <clipPath id="clip0_568_4024">
        <path
          fill="#fff"
          d="M0 0H55.923V14.432H0z"
          transform="translate(230.228 50.56)"
        ></path>
      </clipPath>
    </defs>
  </svg>
  )
}